import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../hooks';
import { getGenerationId } from '../../../../store/GenerationSlice';
import { AppDispatch, RootState } from '../../../../store/store';
import { Mode } from '../../../../types/common';
import { BaseForm, FormInput } from '../../../UI';

const INIT_INPUT = {
  from: '',
  service_name: '',
};
const VALIDATE_FIELDS = ['from', 'service_name'];

interface IEmailFormProps {}

const EmailForm: React.FC<IEmailFormProps> = () => {
  const { input, error, handleChange, submit, resetForm, tags, handleAddTag, handleDeleteTag, handlePressKey } =
    useForm(INIT_INPUT, handleSubmit, VALIDATE_FIELDS);
  const { isGenerationLoading, isHistoryLoading } = useSelector((state: RootState) => state.generation);
  const dispatch = useDispatch<AppDispatch>();

  function handleSubmit() {
    dispatch(getGenerationId({ ...input, tags, mode: Mode.Mail }));
  }

  return (
    <BaseForm onSubmit={submit} onReset={resetForm}>
      <Stack gap={'20px'}>
        <FormInput
          onChange={handleChange}
          error={error?.from || ''}
          name={'from'}
          value={input.from || ''}
          placeholder={'Например, магазин брендовых кроссовок'}
          label={'От кого'}
          maxLength={350}
          required
        />

        <FormInput
          onChange={handleChange}
          error={error?.service_name || ''}
          name={'service_name'}
          value={input.service_name || ''}
          placeholder={'Например, 30% скидка на кроссовки Nike для пар'}
          label={'Тема письма'}
          maxLength={350}
          required
        />

        <FormInput
          onChange={handleChange}
          onAddTag={handleAddTag}
          onDeleteTag={handleDeleteTag}
          onKeyPress={handlePressKey}
          name={'tags'}
          value={input.tags || ''}
          placeholder={'Например, День Святого Валентина'}
          label={'Дополнительные вводные'}
          tags={tags}
          disabled={isGenerationLoading || isHistoryLoading}
          maxLength={30}
        />
      </Stack>
    </BaseForm>
  );
};

export default EmailForm;
